import { useState } from 'react'
import FormErrors from '../components/FormErrors'
import { changePassword } from '../lib/allauth'
import { Navigate } from 'react-router-dom'
import { useUser } from '../auth'
import { Card, Input, Button, Typography } from 'antd'

const { Title, Text } = Typography

export default function ChangePassword () {
  const hasCurrentPassword = useUser().has_usable_password
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPassword2, setNewPassword2] = useState('')
  const [newPassword2Errors, setNewPassword2Errors] = useState([])
  const [response, setResponse] = useState({ fetching: false, content: null })

  function submit () {
    if (newPassword !== newPassword2) { setNewPassword2Errors([{ param: 'new_password2', message: 'Password does not match.' }]); return }
    setNewPassword2Errors([])
    setResponse({ ...response, fetching: true })
    changePassword({ current_password: currentPassword, new_password: newPassword }).then((resp) => { setResponse((r) => { return { ...r, content: resp } }) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }
  if (response.content?.status === 200) return <Navigate to='/dashboard' />
  return (
    <div style={{ maxWidth: 400, margin: '48px auto' }}>
      <Card>
        <Title level={2} className='tti-page-title'>{hasCurrentPassword ? 'Change Password' : 'Set Password'}</Title>
        <Text type='secondary' style={{ fontSize: 13 }}>{hasCurrentPassword ? 'Enter your current password, then your new password.' : 'You have no password set. Enter a new password.'}</Text>
        {hasCurrentPassword && (
          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Current Password</label>
            <Input.Password autoComplete='password' value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} style={{ marginTop: 4 }} />
            <FormErrors param='current_password' errors={response.content?.errors} />
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>New Password</label>
          <Input.Password autoComplete='new-password' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={{ marginTop: 4 }} />
          <FormErrors param='new_password' errors={response.content?.errors} />
        </div>
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>New Password (again)</label>
          <Input.Password value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)} style={{ marginTop: 4 }} />
          <FormErrors param='new_password2' errors={newPassword2Errors} />
        </div>
        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <Button type='primary' loading={response.fetching} onClick={() => submit()}>{hasCurrentPassword ? 'Change' : 'Set'}</Button>
        </div>
      </Card>
    </div>
  )
}
